'use client';

import 'BomdisoftComponents/social/styles.css';
import { joinClasses } from 'BomdisoftComponents/html/index';
import { EmailRoundedIcon, FacebookIcon, GitHubIcon, InstagramIcon, LinkedInIcon, PhoneRoundedIcon, XIcon } from 'BomdisoftComponents/icons/index';
import { socialIcons } from 'BomdisoftComponents/social/render';
import { SocialAccount } from 'BomdisoftComponents/types';
import { callNumberT, getLanguageFromLocale, sendEmailToT, socialMediaLinksT, visitBrandT } from '@bomdisoft/translations';
import { useParams } from 'next/navigation';

export type SocialProps = {
  accounts: SocialAccount;
  className?: string;
  iconClassName?: string;
};

export const Social = ({ accounts, className, iconClassName }: SocialProps) => {
  const params = useParams();
  const language = getLanguageFromLocale(typeof params?.lang === 'string' ? params.lang : undefined);
  const visit = (name: string) => visitBrandT[language].replace('{name}', name);
  return (
    <nav aria-label={socialMediaLinksT[language]} className={joinClasses('bomdisoft-social-holder', className)}>
      {accounts.mobile ? (
        <a aria-label={callNumberT[language].replace('{number}', accounts.mobile)} className='bomdisoft-social-link' data-brand='mobile' href={`tel:${accounts.mobile}`}>
          <PhoneRoundedIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.email ? (
        <a aria-label={sendEmailToT[language].replace('{email}', accounts.email)} className='bomdisoft-social-link' data-brand='email' href={`mailto:${accounts.email}`}>
          <EmailRoundedIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.linkedin ? (
        <a aria-label={visit('LinkedIn')} className='bomdisoft-social-link' data-brand='linkedin' href={accounts.linkedin} rel='noopener noreferrer' target='_blank'>
          <LinkedInIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.facebook ? (
        <a aria-label={visit('Facebook')} className='bomdisoft-social-link' data-brand='facebook' href={accounts.facebook} rel='noopener noreferrer' target='_blank'>
          <FacebookIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.instagram ? (
        <a aria-label={visit('Instagram')} className='bomdisoft-social-link' data-brand='instagram' href={accounts.instagram} rel='noopener noreferrer' target='_blank'>
          <InstagramIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.x ? (
        <a aria-label={visit('X (Twitter)')} className='bomdisoft-social-link' data-brand='x' href={accounts.x} rel='noopener noreferrer' target='_blank'>
          <XIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.github ? (
        <a aria-label={visit('GitHub')} className='bomdisoft-social-link' data-brand='github' href={accounts.github} rel='noopener noreferrer' target='_blank'>
          <GitHubIcon className={iconClassName} />
        </a>
      ) : null}
      {accounts.tiktok ? (
        <a aria-label={visit('TikTok')} className='bomdisoft-social-link' data-brand='tiktok' href={accounts.tiktok} rel='noopener noreferrer' target='_blank'>
          <img alt='' className={iconClassName} height={24} src={socialIcons.tiktok} width={24} />
        </a>
      ) : null}
    </nav>
  );
};
